module.exports = __webpack_public_path__ + "static/media/6-solution-1.6c1c96cb.mp3";